<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('commune.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('commune.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-panel>
      <ts-panel-wrapper>
        <div class="d-flex justify-content-between">
          <div class="ts-flex ts-space-x-1">
            <ts-button outline color="info" @click.prevent="addNew">
              {{ $t('add_new') }}
            </ts-button>
            <ts-button :waiting="exporting" @click.prevent="downloadExcel">
              <i class="fas fa-file-excel"></i>
            </ts-button>
          </div>
          <div class="d-flex ts-items-center">
            <ts-checkbox v-model="hasNoShop" @change="fetchData()">
              {{ $t('commune.hasNoShop') }}
            </ts-checkbox>
            <ts-input
              v-model="search"
              v-tooltip="$t('commune.search')"
              :placeholder="$t('commune.search')"
              style="width: 250px;"
              class="inline-block ts-ml-3"
            />
          </div>
        </div>
      </ts-panel-wrapper>
      <Table
        :columns="columns"
        :data="communeResources"
        size="small"
        :loading="loading"
        highlight-row
        stripe
        max-height="700"
      >
        <template slot-scope="{ row }" slot="communeCode">
          <td class="ts-text-blue-500">{{ row.commune_code }}</td>
        </template>
        <template slot-scope="{ row }" slot="nameKh">
          <td class="ts-text-blue-500">{{ row.name_kh }}</td>
        </template>
        <template slot-scope="{ row }" slot="nameEn">
          <td class="ts-text-blue-500">{{ row.name_en }}</td>
        </template>
        <template slot-scope="{ row }" slot="action">
          <a
            href="#"
            v-tooltip="$t('edit')"
            class="text-primary mr-2"
            @click.prevent="edit(row)"
          >
            <i class="fas fa-edit"></i>
          </a>
          <a
            href="#"
            v-tooltip="$t('edit')"
            class="text-primary mr-2"
            @click.prevent="drawGeofence(row)"
          >
            <i class="fas fa-map-marker-alt"></i>
          </a>
        </template>
      </Table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination
          v-model="communePaginate"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
    </ts-panel>
    <a-modal
      v-if="show_form"
      v-model="show_form"
      :title="!isUpdate ? $t('addNew') : $t('update')"
      :centered="true"
      @cancel="onCancel"
      :footer="null"
    >
      <CommuneForm :record="record" @cancel="onCancel" />
    </a-modal>
    <a-modal
      v-if="isDrawGeofence"
      v-model="isDrawGeofence"
      :title="$t('commune.geofence')"
      :footer="null"
      width="90%"
      :zIndex="1024"
    >
      <Geofence :record="record" @cancel="onCancel" />
    </a-modal>
  </div>
</template>

<script>
import { debounce, isEmpty } from 'lodash'
import { mapState } from 'vuex'
import CommuneForm from './components/commune-form.vue'
import * as FileDownload from 'downloadjs'
import { trim } from 'lodash'
import Geofence from './components/draw-geofence-commune.vue'
export default {
  name: 'branchIndex',
  components: {
    CommuneForm,
    Geofence
  },
  data() {
    return {
      loading: false,
      exporting: false,
      show_form: false,
      isDrawGeofence: false,
      record: {}
    }
  },
  computed: {
    ...mapState('corporate/address', ['communeResources', 'communePaginate']),

    isUpdate() {
      return !isEmpty(this.record)
    },
    search: {
      get() {
        return this.$store.state.corporate.address.search
      },
      set(newValue) {
        this.$store.commit('corporate/address/SET_SEARCH', newValue)
        this.$store.commit('corporate/address/RESET_CURRENT_PAGE')
      }
    },
    hasNoShop: {
      get() {
        return this.$store.state.corporate.address.has_no_shop
      },
      set(newValue) {
        this.$store.commit('corporate/address/SET_HAS_NO_SHOP', newValue)
      }
    },
    columns() {
      return [
        {
          title: this.$t('commune.provinceNameKh'),
          key: 'p_name_kh'
        },
        {
          title: this.$t('commune.districtCode'),
          key: 'district_code'
        },
        {
          title: this.$t('commune.districtNameKh'),
          key: 'd_name_kh'
        },
        {
          title: this.$t('commune.districtNameEn'),
          key: 'd_name_en'
        },
        {
          title: this.$t('commune.communeCode'),
          slot: 'communeCode'
        },
        {
          title: this.$t('commune.nameKh'),
          slot: 'nameKh'
        },
        {
          title: this.$t('commune.nameEn'),
          slot: 'nameEn'
        },
        {
          title: this.$t('actions'),
          key: 'action',
          slot: 'action',
          fixed: 'right',
          align: 'center',
          width: 90
        }
      ]
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('corporate/address/communeFetch', { ...attributes })
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    addNew() {
      this.show_form = true
    },
    edit(record) {
      this.record = record
      this.show_form = true
    },
    drawGeofence(record) {
      this.record = record
      this.isDrawGeofence = true
    },
    onCancel() {
      this.isDrawGeofence = false
      this.show_form = false
      this.record = {}
      this.fetchData()
    },
    downloadExcel() {
      this.exporting = true
      this.$store
        .dispatch('corporate/address/downloadExcel')
        .then(response => {
          let filename = trim(
            response.headers['content-disposition']
              .substring(
                response.headers['content-disposition'].indexOf('filename')
              )
              .replace('filename=', ''),
            '"'
          )
          FileDownload(response.data, filename)
        })
        .catch(err => {
          let error = JSON.parse(
            String.fromCharCode.apply(null, new Uint8Array(err))
          )
          this.$toasted.error(error.message)
        })
        .finally(() => (this.exporting = false))
    }
  },
  watch: {
    search: debounce(function() {
      this.fetchData()
    }, 500)
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fetchData()
    })
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('corporate/address/RESET_STATE')
    next()
  }
}
</script>
